import { z } from 'zod';

export const priceFormSchema = z.object({
  monthlyPriceEnabled: z.boolean(),
  annualPriceEnabled: z.boolean(),
  monthlyPrice: z.string().trim().optional(),
  annualPrice: z.string().trim().optional(),
  monthlyFreeTrial: z.boolean(),
  annualFreeTrial: z.boolean(),
});

export const createBundlePriceFormSchema = priceFormSchema.superRefine(
  (values, ctx) => {
    if (values.monthlyPriceEnabled && !values.monthlyPrice) {
      ctx.addIssue({
        code: 'custom',
        message: 'Required',
        path: ['monthlyPrice'],
      });
    }
    if (values.annualPriceEnabled && !values.annualPrice) {
      ctx.addIssue({
        code: 'custom',
        message: 'Required',
        path: ['annualPrice'],
      });
    }
  },
);

export const bundlePriceFormSchema = createBundlePriceFormSchema.superRefine(
  (values, ctx) => {
    if (!values.monthlyPriceEnabled && !values.annualPriceEnabled) {
      ctx.addIssue({
        code: 'custom',
        message: 'One of the prices must be selected',
        path: ['monthlyPriceEnabled'],
      });
    }
  },
);

export const formDefaultValues = {
  monthlyPriceEnabled: false,
  annualPriceEnabled: false,
  monthlyPrice: undefined,
  annualPrice: undefined,
  monthlyFreeTrial: false,
  annualFreeTrial: false,
};

export type BundleFormValues = z.infer<typeof bundlePriceFormSchema>;

export type CreateFormValues = z.infer<typeof createBundlePriceFormSchema>;
